"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgFilesAlt = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21.414 4L18 .589A2.01 2.01 0 0016.586 0H7a2 2 0 00-2 2v1H4a2 2 0 00-2 2v17a2 2 0 002 2h13a2 2 0 002-2v-1h1a2 2 0 002-2V5.414A1.99 1.99 0 0021.414 4zM17 21.5a.5.5 0 01-.5.5h-12a.5.5 0 01-.5-.5v-16a.5.5 0 011 0V19a2 2 0 002 2h9.5a.5.5 0 01.5.5zm2.5-2.5a.5.5 0 00.5-.5V5.621a.5.5 0 00-.146-.353l-3.122-3.122A.5.5 0 0016.379 2H7.5a.5.5 0 00-.5.5v16a.5.5 0 00.5.5h12z", clipRule: "evenodd" })));
};
exports.default = SvgFilesAlt;
//# sourceMappingURL=FilesAlt.js.map